"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MIN_PAGE_HEIGHT = void 0;
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
var _createThemeOptions = require("../theme/create-theme-options");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MIN_PAGE_HEIGHT = exports.MIN_PAGE_HEIGHT = '60vh';
const RicePaper = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    page,
    sx: _sx,
    ...props
  } = _ref;
  let theme = (0, _material.useTheme)();
  theme = _react.default.useMemo(() => {
    return (0, _material.createTheme)(theme, (0, _createThemeOptions.createRicePaperThemeOptions)(theme));
  }, [theme]);
  const sx = [_sx, page && {
    minHeight: MIN_PAGE_HEIGHT
  }];
  return /*#__PURE__*/_react.default.createElement(_material.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_material.Paper, _extends({
    ref: ref,
    sx: sx
  }, props)));
});
RicePaper.defaultProps = {
  square: true,
  page: false
};
var _default = exports.default = RicePaper;